import { useForm } from "@mantine/form";
import { Button, Flex, Loader, Center, PasswordInput, Select, TextInput } from "@mantine/core";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import { getHrUsersList, updateHrUserById } from "../../api/hrUserApi"; // getHrUsersById → getHrUsersList
import { updateNotification } from "../../utils/useNotification";
import Container from "../common/Container";
import { ActionIcon } from "@mantine/core";
import { IconArrowLeft } from "@tabler/icons-react";
import styled from "styled-components";
import { combineValidators, validateMaxLength, validateMinLength, validateRequired } from "../../utils/validations";

const PanelUserUpdateForm = () => {
  const navigate = useNavigate();
  const { id, userId } = useParams(); 
  console.log("PARAMS:", id, userId); 

  const [loading, setLoading] = useState(true);

  const form = useForm({
    initialValues: { name: "", privilege: "", phone: "", password: "" },
    validate: {
      name: validateRequired,
      privilege: validateRequired,
      password: (value) => value ? combineValidators(validateMaxLength(16), validateMinLength(4))(value) : null,
    },
  });

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const res: any = await getHrUsersList({ 
          companyId: id as string,
          limit: 999,
          pageNumber: 1, 
        });
        const list = res?.data?.data;
        const userData = list?.find((u: any) => u._id === userId);

        if (userData) {
          form.setValues({
            name: userData.name ?? "",
            privilege: userData.privilege ?? "",
            phone: userData.phone?.startsWith("+90")
              ? "0" + userData.phone.slice(3)
              : userData.phone ?? "",
            password: "",
          });
        }
      } catch (error) {
        console.error("Fetch error:", error);
      } finally {
        setLoading(false);
      }
    };
    if (userId && id) fetchUser();
  }, [userId, id]);

  const handleSubmit = async (values: any) => {
    try {
      const updates = { ...values };
      if (!updates.password) delete updates.password;
      const { data }: any = await updateHrUserById({ id: userId, updates });
      updateNotification(data?.success);
      navigate(`/companies/detail/${id}?tab=user`);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  if (loading) return <Center h={400}><Loader color="#5C26FF" /></Center>;

  return (
    <Container>
      <ActionIcon variant="subtle" color="#5c26ff" size={44} onClick={() => navigate(`/companies/detail/${id}?tab=user`)}>
        <IconArrowLeft size={28} />
      </ActionIcon>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", minHeight: "70vh"}}>
        <PageTitle><Title>Panel Kullanıcısı Güncelleme</Title></PageTitle>
        <form style={{ display: "flex", flexDirection: "column", gap: "15px", width: "min(468px, 100%)", marginTop: "20px" }}
          onSubmit={form.onSubmit(handleSubmit)}>
          <TextInput label="Ad Soyad" radius={10} size="md" {...form.getInputProps("name")} />
          <Select label="Yetki" radius={10} size="md"
            data={[{ value: "admin", label: "Admin" }, { value: "user", label: "User" }]}
            {...form.getInputProps("privilege")} />
            <TextInput label="Telefon" radius={10} size="md" maxLength={11}{...form.getInputProps("phone")} />
          <PasswordInput label="Şifre" placeholder="Değiştirmek istemiyorsanız boş bırakın." radius={10} size="md" {...form.getInputProps("password")} />
          <Flex gap={10} mt={10}>
            <Button variant="outline" color="gray" radius={10} fullWidth onClick={() => navigate(`/companies/detail/${id}?tab=user`)}>Vazgeç</Button>
            <Button color="#5C26FF" radius={10} type="submit" fullWidth>Güncelle</Button>
          </Flex>
        </form>
      </div>
    </Container>
  );
};

export default PanelUserUpdateForm;

const PageTitle = styled.div`display: flex; flex-direction: column; justify-content: center; text-align: center; gap: 12px;`;
const Title = styled.div`font-size: 24px; font-weight: 600; line-height: 24px; color: black;`;